import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/nominas/polizas-de-carga-externa/';

/**
 * GET Polizas De Carga Externa
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPolizasDeCargaExterna = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Poliza De Carga Externa
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPolizaCargaExterna = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Poliza De Carga Externa
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPolizaCargaExterna = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Poliza De Carga Externa
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPolizaCargaExterna = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Poliza De Carga Externa
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePolizaCargaExterna = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
